import React from 'react';
export function MechanismSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#0B1A2E]" data-id="element-77">
      <div className="max-w-3xl mx-auto animate-fade-in-up delay-100" data-id="element-78">
        <div className="text-center mb-12" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-80">
            Introducing the Dopamine-Menu (Dos-M) Framework.
          </h2>
          <div className="w-24 h-1 bg-[#2DD4BF] mx-auto rounded-full" data-id="element-81" />
        </div>

        <div className="bg-[#112240] border-2 border-[#2DD4BF] rounded-2xl p-8 md:p-10 mb-10 shadow-[0_0_30px_rgba(45,212,191,0.1)]" data-id="element-82">
          <p className="text-xl md:text-2xl text-[#F1F5F9] font-serif text-center leading-snug" data-id="element-83">
            "Most productivity systems focus on Time Management, but ADHD is a{' '}
            <span className="text-[#2DD4BF] font-bold" data-id="element-84">
              Dopamine Management
            </span>{' '}
            issue."
          </p>
        </div>

        <div className="space-y-6 text-[#94A3B8] text-lg leading-relaxed" data-id="element-85">
          <p data-id="element-86">
            Instead of fighting your brain with willpower, we feed it with
            intention.
          </p>
          <p data-id="element-87">
            This toolkit gives you a menu of 5-minute chemical "appetizers" that
            wake up your prefrontal cortex, allowing you to slide into deep work
            without the typical friction or pain.
          </p>
        </div>
      </div>
    </section>;
}